/* eslint-disable import/prefer-default-export */
import * as Redux from 'redux'
import { reducer as reducerSummary } from './summary'
import { reducer as reducerDetails } from './details'
import { reducer as reducerCRUD } from './organization.crud'

export const reducer = Redux.combineReducers({
  summary: reducerSummary,
  details: reducerDetails,
  editor: reducerCRUD
})
